<div class="image-dialog-content">
  @if (!imageLoaded && !loadError) {
    <p-progressSpinner
      strokeWidth="4"
      styleClass="custom-spinner"
    />
  }
  @if (imageUrl) {
    <img
      [src]="imageUrl"
      [alt]="altText || 'Prévisualisation de l\'image'"
      (load)="onImageLoad()"
      (error)="onImageError()"
      [style.display]="imageLoaded ? 'block' : 'none'"
      style="max-width: 100%; max-height: 75vh; object-fit: contain; margin: auto"
    />
  }
  @if (loadError) {
    <div class="error-message">
      <p i18n="@@image_dialog_error_message">Impossible de charger l'image.</p>
    </div>
  }
  <div class="dialog-footer p-dialog-footer">
    <p-button
      (click)="closeDialog()"
      i18n-label="@@image_dialog_button_close"
      label="Fermer"
      styleClass="p-button-text"
    />
  </div>
</div>
